import React from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { sort } from '@utility/helperFunction';
import { TouchableDiv } from '@components/common/Touchable';
import style from '../MenuContentHeader.module.scss';
const MenuSeats = ({ serverAppTheme, check, position, cart, handleSeatClick }) => {
  return (
    check?.seats?.length > 0 &&
    sort(check?.seats, 'number').map(item => {
      const hasPending = cart?.some(pending =>
        pending.seatIds?.includes(item.id)
      );
      const isSelected = position.number === item.number;

      // Determine background and color
      const background = hasPending
        ? isSelected
          ? serverAppTheme?.primaryBtn
          : '#F7E59E'
        : isSelected
        ? serverAppTheme?.primaryBtn
        : serverAppTheme?.tip_tile;
      const textColor =
        hasPending && !isSelected
          ? 'black'
          : isSelected
          ? 'white'
          : serverAppTheme?.primary_text;

      // Determine classes
      const classes = cn(
        style.btnBorderWhite,
        style.btnStyle,
        !isSelected ? style.btnGray : null,
        isSelected ? style.selectedSeatBg : '',
        hasPending && !isSelected ? style.pendingSeatBg : '',
        'btn-ripple text-center py-1 rounded fs_20  position-relative'
      );
      return (
        <div key={item.id} className="d-flex">
          {item.open && (
            <div className="pr-1">
              <TouchableDiv
                role="presentation"
                onClick={() => {
                  handleSeatClick(item);
                }}
                className={classes}
                style={{ background, color: textColor }}
                rippleEffect={true}
              >
                <span>{item.number}</span>
              </TouchableDiv>
            </div>
          )}
        </div>
      );
    })
  );
};

const mapStateToProps = state => ({
  check: state.orders.seats,
  position: state.orders.position,
  auth: state.oauth.authInfo,
  cart: state.orders.cart,
  serverAppTheme: state.theme.serverAppTheme,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

MenuSeats.propTypes = {
  check: PropTypes.object.isRequired,
  cart: PropTypes.array.isRequired,
  position: PropTypes.object.isRequired,
  serverAppTheme: PropTypes.object.isRequired,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(MenuSeats));
